module.exports = __webpack_public_path__ + "img/46.fdb9a03b.fdb9a03b.svg";